import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider} from 'mobx-react';
import {Root} from "./containers/Root";
import {EUnwrapStage} from "./models/UIModel";
import {UIStore} from "./stores/UIStore";
import './../index.css';
import PStore from "./stores/PStore";
import RStore from "./stores/RStore";

export class UI {

    // prepare MobX stores
    public static UI_STORE:UIStore;
    public static P_STORE:PStore;
    public static R_STORE:RStore;

    private static unifiedStore:{[key:string]:any};

    /**
     * Renders the plugin after loading/connecting
     */
    public static initialize():void {

        // initialize stores
        UI.initializeStores();

        // render UI
        ReactDOM.render(
            // add stores to provider for later injection
            <Provider {...UI.unifiedStore}>
                    <Root/>
            </Provider>,
            document.getElementById('root')
        );
    }

    private static initializeStores():void {

        // initialize UI store
        UI.UI_STORE = new UIStore(
            {
                stage:EUnwrapStage.Identify,
            }
        );

        // initialize P store
        UI.P_STORE = new PStore(
            {
                puzzleRecord: null as any, // start with no information for puzzle records on startup
            }
        );

        // initialize R store
        UI.R_STORE = new RStore(
            {
                recipientRecord: null as any, // start with no information for recfipient records on startup
            }
        );

        // initialize unified store
        UI.unifiedStore = {
            UI_STORE:UI.UI_STORE,
            P_STORE:UI.P_STORE,
            R_STORE:UI.R_STORE
        };
    }
}